class QuestionAnswerBoxComponent extends HTMLElement {

  _template = document.createElement('template');
  _productPageButton = null;
  _questionAnswerBoxEl = null;
  _questionEl = null;
  _answerEl = null;
  _answerSlotEl = null;
  _questionAnswerBoxInnerEl = null;

  constructor() {
    super();

    //language=HTML
    this._template.innerHTML = `
      <style>
        @import "/css/main.css";
      </style>
      
      <div class="question-answer-box">
        <div class="question-answer-box__inner">
          <div class="question-answer-box__inner__left">
            <button class="product-page-button">
              <i class="icon2-qa-arrow-default"></i>
            </button>
          </div>
          <div class="question-answer-box__inner__right">
            <div class="question">
              <slot name="question"></slot>
            </div>
            <div class="answer">
              <slot name="answer"></slot>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  connectedCallback() {
    const shadowRoot = this.attachShadow({ mode: 'open' });

    shadowRoot.appendChild(this._template.content.cloneNode(true));

    this.queryElements();
  }

  queryElements() {
    this._questionAnswerBoxEl = this.shadowRoot.querySelector('.question-answer-box');
    this._productPageButton = this.shadowRoot.querySelector('.product-page-button');
    this._questionEl = this.shadowRoot.querySelector('.question');
    this._answerEl = this.shadowRoot.querySelector('.answer');
    this._answerSlotEl = this.shadowRoot.querySelector('slot[name="answer"]').assignedNodes()[0];
    this._questionAnswerBoxInnerEl = this.shadowRoot.querySelector('.question-answer-box__inner');

    this.initListeners();
  }

  initListeners() {
    [this._questionEl, this._productPageButton].forEach(x => x.addEventListener('click', this.toggleBox.bind(this)));

    window.addEventListener('resize', () => {
      this._questionAnswerBoxEl.classList.remove('active');
      this.classList.remove('active');

      this._answerEl.style.maxHeight = '0px';
    });
  }

  toggleBox() {
    this._questionAnswerBoxEl.classList.toggle('active');
    const isActive = this.classList.toggle('active');

    this._answerEl.style.maxHeight = (isActive ? this._answerSlotEl.offsetHeight + 10 : 0) + 'px';
  }
}

window.customElements.define('cc-question-answer-box', QuestionAnswerBoxComponent);
